<wms-dialog-header title="{{locale[caption]}}" (onClose)="closeModal()"></wms-dialog-header>
<wms-dialog-body>
    <p class="app-dialog-message">{{content}}</p>
</wms-dialog-body>
<wms-dialog-footer>
    <button class="cancel-action btn app-button btn-secondary" title="{{locale.LABEL_CANCEL}}"
        (click)="closeModal()"><span class="btn-caption">{{locale.LABEL_CANCEL}}</span></button>
    <button class="btn-primary ok-action btn app-button" title="{{locale.LABEL_OK}}" (click)="onOk()">
        <span class="btn-caption">{{locale.LABEL_OK}}</span></button>
</wms-dialog-footer>